import { formatFullName } from "../../../../utils/format";

export const transformUsers = rawUsers => rawUsers.map(user => {
    const { profile: {city, address, ...profile}, ...rest } = user;
  return {
    ...profile,
    fullName: formatFullName(profile),
    address: {
      city,
      address
    },
    ...rest
  }
});
